export const PROJECTS = [
  {
    id: "lesreines",
    title: "Lesreines",
    category: "E-commerce",
    year: "2025",
    description: "Boutique en ligne de perruques haut de gamme : élégance, confiance et raffinement.",
    longDescription:
      "Lesreines, c'est la boutique en ligne où chaque femme se sent reine. J'ai conçu une expérience d'achat immersive : visuels éditoriaux plein écran, catalogue de perruques premium clair et élégant, prise de rendez-vous intégrée et paiement sécurisé. Découvrez comment le design peut sublimer un produit — et donner envie de rester.",
    tech: ["Boutique en ligne", "Catalogue produits", "Réservation", "Paiement sécurisé"],
    image: "/projects/lesreines.jpg",
    duration: "E-commerce",
    role: "Design & Développement",
    url: "https://lesreines.ca/",
  },
  {
    id: "giav",
    title: "Giav",
    category: "E-commerce",
    year: "2025",
    description: "Boutique en ligne d'une marque de vêtements chrétiens au style affirmé.",
    longDescription:
      "Giav porte un message fort, et son site devait le faire ressentir dès la première seconde. Visuels impactants, catalogue épuré, fiches produits soignées et tunnel d'achat sans friction : une boutique pensée pour convertir sans jamais trahir l'identité de la marque. Allez jeter un œil, la collection vaut le détour.",
    tech: ["Boutique en ligne", "Catalogue produits", "Paiement sécurisé", "Design responsive"],
    image: "/projects/giav.jpg",
    duration: "E-commerce",
    role: "Design & Développement",
    url: "https://giav.ca/",
  },
  {
    id: "dancreations",
    title: "Dancreation",
    category: "Portfolio",
    year: "2025",
    description: "Portfolio d'une créatrice de contenu, pensé pour mettre l'image au premier plan.",
    longDescription:
      "Pour Dancreation, créatrice de contenu, l'objectif était simple : un portfolio aussi inspirant que son univers. Navigation fluide, galerie généreuse et mise en page qui laisse respirer les visuels — une vitrine qui présente ses collaborations et ses réalisations avec style. Explorez-le pour voir l'image prendre toute la place.",
    tech: ["Portfolio", "Galerie", "Identité visuelle", "Design responsive"],
    image:
      "https://images.unsplash.com/photo-1673767298248-b128f17f89af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxjb250ZW50JTIwY3JlYXRvciUyMHdvbWFuJTIwZmlsbWluZyUyMGNhbWVyYXxlbnwwfHx8fDE3OTEyNjkyNzJ8MA&ixlib=rb-4.1.0&q=85",
    duration: "Portfolio",
    role: "Design & Développement",
    url: "https://www.dancreations.com/",
  },
  {
    id: "louvena-metellus",
    title: "Louvena Metellus",
    category: "Vitrine/Artistique",
    year: "2024",
    description: "Site vitrine d'une artiste gospel, aux couleurs de son univers musical.",
    longDescription:
      "Louvena Metellus transmet une émotion sur scène ; son site devait la prolonger en ligne. Biographie, EP, musique et galerie photo réunis dans une expérience immersive et colorée, avec une section contact pour les demandes de collaboration et de prestation. Entrez dans son univers, vous allez l'entendre avant même d'appuyer sur lecture.",
    tech: ["Site vitrine", "Musique & EP", "Galerie photo", "Design responsive"],
    image: "/projects/louvena.jpg",
    duration: "Site vitrine",
    role: "Design & Développement",
    url: "https://louvenametellus.com/",
  },
];

export const CATEGORIES = ["Tous", "E-commerce", "Portfolio", "Vitrine/Artistique"];

export const TESTIMONIALS = [
  {
    id: "giav",
    quote:
      "Merdi a compris l'âme de Giav dès le premier échange. Le site reflète exactement notre message et nos ventes en ligne ont décollé dès le lancement.",
    name: "Équipe Giav",
    role: "Marque de vêtements chrétiens",
    url: "https://giav.ca/",
  },
  {
    id: "lesreines",
    quote:
      "Un travail d'une élégance rare. Nos clientes nous disent qu'elles se sentent déjà reines en parcourant la boutique. Réactif, créatif et à l'écoute.",
    name: "Lesreines",
    role: "Boutique de perruques haut de gamme",
    url: "https://lesreines.ca/",
  },
  {
    id: "louvena",
    quote:
      "Mon site est le prolongement de ma musique : coloré, vivant, fidèle à mon univers. Merdi a su traduire une émotion en design.",
    name: "Louvena Metellus",
    role: "Artiste gospel",
    url: "https://louvenametellus.com/",
  },
];

export const MARQUEE_ITEMS = [
  "Sites Sur-Mesure",
  "Animations WebGL",
  "Design Systems",
  "E-Commerce",
  "Performance",
  "UI/UX Design",
  "Développement Front-End",
  "Direction Artistique",
];

export const SERVICES = [
  {
    icon: "PenTool",
    title: "Création Sur-Mesure",
    description:
      "Des sites pensés pour vous : conçus entièrement sur-mesure ou bâtis sur une base solide que je personnalise de A à Z. Une identité digitale qui vous ressemble, sans compromis.",
    tags: ["Landing Pages", "Sites Vitrines", "Portfolios"],
    span: "md:col-span-7",
  },
  {
    icon: "Component",
    title: "Design System & UI/UX",
    description:
      "Des systèmes de design cohérents et documentés qui accélèrent vos équipes et unifient vos produits.",
    tags: ["Figma", "Tokens", "Composants"],
    span: "md:col-span-5",
  },
  {
    icon: "Gauge",
    title: "Performance & SEO",
    description:
      "Des scores Lighthouse au vert, un référencement solide et une expérience instantanée sur tous les appareils.",
    tags: ["Core Web Vitals", "Accessibilité", "Audit"],
    span: "md:col-span-7",
  },
];

export const CHAPTERS = [
  {
    number: "01",
    title: "L'Obsession du Détail",
    text: "Un pixel mal aligné me réveille la nuit. Chaque espacement, chaque courbe d'animation et chaque graisse typographique est délibéré. C'est dans ces détails invisibles que naît la sensation de qualité.",
  },
  {
    number: "02",
    title: "L'Harmonie Code & Art",
    text: "Je ne fais pas la différence entre designer et développeur. Le code est mon pinceau : je sculpte des interfaces où la technique disparaît derrière l'émotion, sans jamais sacrifier la performance.",
  },
  {
    number: "03",
    title: "L'Impact Mesurable",
    text: "Le beau doit servir l'utile. Chaque projet est piloté par des objectifs concrets : conversion, rétention, vitesse. Un site réussi est un site qui fait grandir votre activité.",
  },
];

export const SKILLS = [
  "React",
  "TypeScript",
  "Three.js",
  "GSAP",
  "Tailwind CSS",
  "FastAPI",
  "Node.js",
  "Figma",
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHw0fHxkYXJrJTIwbW9kZXJuJTIwd2ViJTIwZGV2ZWxvcG1lbnQlMjBkZXNpZ24lMjBhYnN0cmFjdCUyMGRpZ2l0YWwlMjBhcnR3b3JrfGVufDB8fHx8MTc4ODI5MTkzNnww&ixlib=rb-4.1.0&q=85";

export const PORTRAIT_IMAGE = "/portrait-merdi.jpg";
